module.exports = __webpack_public_path__ + "static/img/watertank.d0ab7af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/corridor/watertank.svg
// module id = 165
// module chunks = 2